import * as React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import * as c from 'models/constants';
import { IArticleCardData } from 'models/magazine/article/articlecard';
import { ErrorPage } from 'containers';
import { thumbUrl } from 'helpers/common';
require('./style.css');

interface IProps {
	nextArticle?: IArticleCardData;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class NextArticle extends React.Component<IProps, any> {
	public render() {
		if (this.props.nextArticle.error) {
			return <ErrorPage {...this.props} message={this.props.nextArticle.message} />;
		}

		const { item } = this.props.nextArticle;
		const { t } = this.props;

		let content: JSX.Element = null;
		if (item) {
			content = (
				<Link to={'/magazine/article/' + item.code} className="nextArticleContainer">
					<span className="backgroundImage" style={{ backgroundImage: `url(${thumbUrl(item.picture)})` }} />
					<span className="textHolder">
						<span className="topText">{t('Magazine_Article_NextArticle_Label_NextArticle')}</span>
						<span className="nextArticleTitle">{item.title}</span>
					</span>
				</Link>
			);
		}

		return content;
	}
}
export { NextArticle };
